"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Object.freeze({
    PLAYER_DATA: 'playerData',
    // @deprecated "GET_TOKEN` will slowly be replaced by "PLAYER_DATA".
    GET_TOKEN: 'getToken',
    LOGIN: 'login',
    UPDATE_LANGUAGE: 'updateLanguage',
    LOGOUT: 'logout',
    IS_AUTHENTICATED: 'isAuthenticated',
    UPDATE_CURRENCY: 'updateCurrency',
    GET_CONFIG: 'getConfig',
    REGISTER: 'register',
    UPDATE_BALANCE: 'updateBalance',
    RESIZE: 'resize',
    SCROLLTO: 'scrollTo',
    TRACKING: 'tracking',
    HOW_TO_PLAY: 'howToPlay',
    REDIRECT: 'redirect',
    ADD_TO_BETSLIP: 'addToBetslip',
    SHARE: 'share',
    JOIN: 'join',
    UPDATE_COUNTRY_CODE: 'updateCountryCode',
    UPSELL: 'upsell',
    LAUNCH_GAME: 'launchGame',
    GAME_LIST: 'gameList'
});
